export { Star as default } from './Star';
